// biome-ignore lint/suspicious/noShadowRestrictedNames: <This is a lodash util, it's fine>
import { isFinite, isNumber } from 'lodash';

import { formatBytes } from '@air/utilities';

export const formatUploadSpeedText = (speed: number | null) => {
  if (!isNumber(speed) || !isFinite(speed)) {
    return;
  }

  return `${formatBytes(speed, { numberOfDecimals: 2 })}/s`;
};
